<template>
  <!-- 扫码支付 -->
  <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false" @open="generateQrCode" :before-close="handlePayDialogClose">
    <div class="flex_center_center">
      <div ref="qrcodeRef" style="width: 200px; height: 200px;"></div>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcodejs2';
import { orderPayCheckApi } from "../../../api/index";
export default {
  name: "WechatPayDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    wxUrl: {
      type: String,
      default: "",
    },
    orderNo: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: false,
      // 支付检查定时器
      payCheckInterval: null,
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    generateQrCode() {
      console.log("生成二维码，URL:", this.wxUrl);
      // 使用$nextTick确保DOM元素已经渲染
      this.$nextTick(() => {
        if (this.wxUrl) {
          // 获取二维码容器
          const qrContainer = this.$refs.qrcodeRef;
          if (!qrContainer) {
            console.error('二维码容器不存在');
            return;
          }

          // 清空之前的二维码
          qrContainer.innerHTML = '';

          // 生成新的二维码
          try {
            new QRCode(qrContainer, {
              text: this.wxUrl,
              width: 200,
              height: 200,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.H
            });
            console.log('二维码生成成功');
          } catch (error) {
            console.error('二维码生成失败:', error);
          }
        }
      });
    },
    // 手动关闭前确认;支付成功的自动关闭不经过此钩子
    handlePayDialogClose(done) {
      this.$confirm('确定要关闭支付窗口吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除支付检查定时器
        if (this.payCheckInterval) {
          clearInterval(this.payCheckInterval);
          this.payCheckInterval = null;
        }
        // 关闭对话框
        done();
      }).catch(() => {
        // 取消关闭
      });
    },
    checkPay() {
      // 清除之前的定时器
      if (this.payCheckInterval) {
        clearInterval(this.payCheckInterval);
      }

      // 开始新的定时检查
      this.payCheckInterval = setInterval(() => {
        orderPayCheckApi(this.orderNo)
          .then((res) => {
            if (res.resultData && res.resultData.payStatus) {
              // 支付成功，清除定时器并跳转到订单管理
              clearInterval(this.payCheckInterval);
              this.payCheckInterval = null;
              // 下单成功后通知父组件清空列表
              this.$emit('pay-success');
              // 清空localStorage
              localStorage.removeItem('customOrders');
              this.dialogVisible = false;
              this.$store.commit("UPDATE_USER_COUPON", null);
              this.$store.commit("UPDATE_ACTIVE_MENU", "6-2");
              this.$router.push({
                name: "orderManege",
              });
            }
          })
          .catch(() => {
            // 单次轮询失败静默，等待下一次轮询
          });
      }, 1000);
    },
  },
};
</script>
